'use client';

// npm packages
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { resendOtp } from '@/redux/thunk/my-profile-thunk';
import { cn } from '@/utils/cn';
import { LOGIN_ERROR_MESSAGE } from '@/constants';
import ErrorMessage from './ErrorMessage';
import Button from '../Button';
import Text from '../Text';

function MyProfileResendOTP() {
  const dispatch = useDispatch();
  const {
    timer,
    isNumberOfAttemptExceeded,
    resending,
    isResendAttemptExceeded,
    errorMessage,
  } = useSelector((state) => state.myProfile);
  const { LAST_RESEND_ATTEMPT } = LOGIN_ERROR_MESSAGE;

  const handleResendOtp = async () => {
    if (!isNumberOfAttemptExceeded) {
      await dispatch(resendOtp({}));
    }
  };

  const formatDuration = (seconds) => {
    const minutes = String(Math.floor(seconds / 60)).padStart(2, '0');
    seconds %= 60;
    const formattedSeconds = String(seconds).padStart(2, '0');

    return `${minutes}:${formattedSeconds}`;
  };

  return (
    <>
      <div className="flex flex-row items-center mb-24">
        <Text
          type="paragraph"
          className="text-12 text-stone-500 text-center font-encode-sans font-medium leading-16 tracking-[0.24px]"
        >
          Didn&apos;t receive OTP? Try again in&nbsp;
        </Text>
        {timer > 0 && !isNumberOfAttemptExceeded && (
          <Text
            type="paragraph"
            className="text-14 text-richcarmine font-encode-sans font-bold leading-20 tracking-[0.28px]"
          >
            {formatDuration(timer)}
          </Text>
        )}
        {timer <= 0 && !isNumberOfAttemptExceeded && resending && (
          <p className="text-xl font-bold animate-pulse text-red-600">...</p>
        )}
        {timer <= 0 && !isNumberOfAttemptExceeded && !resending && (
          <Button
            type="link"
            onClick={() => handleResendOtp()}
            className="!p-0"
            disabled={isNumberOfAttemptExceeded || isResendAttemptExceeded}
          >
            <Text
              type="paragraph"
              className={cn(
                'text-14 text-richcarmine font-bold font-encode-sans leading-20 tracking-[0.28px]',
                {
                  '!text-atelier':
                    isNumberOfAttemptExceeded || isResendAttemptExceeded,
                },
              )}
            >
              Resend OTP
            </Text>
          </Button>
        )}
      </div>
      {errorMessage === LAST_RESEND_ATTEMPT ? (
        <ErrorMessage
          textPrimary="You have one more OTP resend left"
          type="otpError"
        />
      ) : null}

      {isResendAttemptExceeded && !isNumberOfAttemptExceeded ? (
        <ErrorMessage
          textPrimary="Too many OTP resend attempted."
          textSecondary="OTP resend locked for a few minutes."
          type="maxResendSendError"
        />
      ) : null}
    </>
  );
}

export default MyProfileResendOTP;
